import { render, staticRenderFns } from "./ListWines.vue?vue&type=template&id=749d9f78&scoped=true&"
import script from "./ListWines.vue?vue&type=script&lang=js&"
export * from "./ListWines.vue?vue&type=script&lang=js&"
import style0 from "./ListWines.vue?vue&type=style&index=0&id=749d9f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d9f78",
  null
  
)

export default component.exports